// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Recebimentos_GetAvailableForPaymentRulesInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /recebimentos/getAvailableRecebimentosForPaymentRules
 *
 * Gets available recebimentos for payroll period by payment rules.
 * Used by Revenue Conciliation Wizard (Step 3).
 */
import { registerContract } from './validate'

export interface Recebimentos_GetAvailableForPaymentRulesInput {
franchise_id: number
start_date: string
end_date: string
payment_rule_ids?: number[]
user_ids?: string[]
}

registerContract('Recebimentos_GetAvailableForPaymentRulesInput', {
  franchise_id:     { type: 'number',  required: true },
  start_date:       { type: 'string',  required: true },
  end_date:         { type: 'string',  required: true },
  payment_rule_ids: { type: 'array',   required: false },
  user_ids:         { type: 'array',   required: false },
})
